import {
  PriceDisplayEnum,
  PriceDisplay,
  SortOption,
  SortOptionEnum,
} from 'src/components/price-list/types';
import { Variant, ProductCondition, FilterType } from '../../../types';
import {
  getPriceDisplayFromUserSettings,
  getSortingFromUserSettings,
} from '../components/price-list/offer-list-filters/utils';
import queryString from 'query-string-for-all';
import { initialFilterState } from '../constants';
import { ProductActionType } from '../actions/types';

type State =
  | {
      campaigns: any[] | null;
      priceDisplay: PriceDisplay;
      sorting: SortOption;
      variant: Variant;
      condition: ProductCondition;
      options: {
        showInternational: boolean;
        showUsedProducts: boolean;
        showNotInMintCondition: boolean;
        showUnavailable: boolean;
        showPickupOnly: boolean;
        showPricesInclShipping: boolean;
      };
    }
  | undefined;

type Action =
  | {
      type: ProductActionType.PRICE_SHIPPING_DISPLAY;
      priceDisplay: PriceDisplay;
    }
  | {
      type: ProductActionType.PRODUCT_VARIANT_SELECTED;
      variant: Variant;
    }
  | {
      type: ProductActionType.PRODUCT_CONDITION_SELECTED;
      condition: ProductCondition;
    }
  | {
      type: ProductActionType.CAMPAIGNS_RECEIVE;
      campaigns: any[] | null;
    }
  | {
      type: ProductActionType.OFFER_SORTING;
      sorting: SortOption;
    }
  | {
      type: ProductActionType.ROUTE_LOADED;
      location: Location;
      data: any;
      errors: any;
    };

export const defaultProductState = {
  campaigns: null,
  variant: { id: 0 }, // variant.id === 0 corresponds to "all", which is set to default selected value here
  priceDisplay: PriceDisplayEnum.PRICE,
  sorting: SortOptionEnum.PRICE,
  condition: 'new' as ProductCondition,
  filter: null as FilterType[] | null,
  options: initialFilterState,
};

const getProductState = (action: Action) => {
  const state = { ...defaultProductState };
  state.priceDisplay =
    getPriceDisplayFromUserSettings() || defaultProductState.priceDisplay;
  state.sorting = getSortingFromUserSettings() || defaultProductState.sorting;

  if (action.type === 'ROUTE_LOADED') {
    const { filters } = queryString.parse(action.location.search) ?? null;
    const queryFilter = Array.isArray(filters)
      ? (filters as FilterType[])
      : (filters?.split(',') as FilterType[]);

    state.filter = queryFilter;
  }
  return state;
};

export default (state: State, action: Action) => {
  if (!state) {
    return getProductState(action);
  }

  switch (action.type) {
    case ProductActionType.CAMPAIGNS_RECEIVE: {
      return {
        ...state,
        campaigns:
          action.campaigns &&
          action.campaigns.filter(campaign => campaign.state === 'ACTIVE'),
      };
    }

    case ProductActionType.PRICE_SHIPPING_DISPLAY: {
      return {
        ...state,
        priceDisplay: action.priceDisplay,
      };
    }

    case ProductActionType.PRODUCT_VARIANT_SELECTED: {
      return {
        ...state,
        variant: action.variant,
      };
    }

    case ProductActionType.PRODUCT_CONDITION_SELECTED: {
      return {
        ...state,
        condition: action.condition,
      };
    }

    case ProductActionType.OFFER_SORTING: {
      return {
        ...state,
        sorting: action.sorting,
      };
    }

    default:
      return state;
  }
};
